




// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import RecommendationList from "@/components/recommendation/recommendationList.vue";

@Component({
  name: "RecommendationsPage",
  components: {RecommendationList},
})
export default class RecommendationsPage extends Vue {}
